module.exports = "https://cdn.dove.it/_next/static/public/assets/landings/join-our-agents-b/vantaggio_appuntamenti.f9f1d8fb1c857524e612e7c8a50fe042.jpg";